import React from 'react';

type PlatformPayButtonProps = {
  // Must be unique per page, see getFieldsForPlatform in usecollectJS.tsx.
  id: string;
  children?: React.ReactNode;
};

// Container Collect.js mounts the Apple/Google Pay button into. Laid out like
// the regular pay buttons (see .platform-button in main.css).
export default function PlatformPayButton({
  id,
  children,
}: PlatformPayButtonProps) {
  return (
    <div className="pt-3 ion-text-center">
      <div id={id} className="platform-button">
        {children}
      </div>
    </div>
  );
}
